var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#47494D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13L20 14H15V16H16V31C16 31.5222 16.1913 32.0546 16.5684 32.4316C16.9454 32.8087 17.4778 33 18 33H28C28.5222 33 29.0546 32.8087 29.4316 32.4316C29.8087 32.0546 30 31.5222 30 31V16H31V14H26L25 13H21ZM18 16H28V31H18V16ZM20 18V29H22V18H20ZM24 18V29H26V18H24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTrashIcon);
export default __webpack_public_path__ + "static/media/img-trash-icon.4830dcb35b6de4a2f2a9933b15962fe6.svg";
export { ForwardRef as ReactComponent };